import {Dimensions} from 'react-native'

const { width, height } = Dimensions.get('window')
//const { height,} = Dimensions.get('window')

const ApplicationStyles = {
    mainContainer: {
        flex: 1,
        flexWrap: 'wrap',
    },
    main1Container: {
        flex: 1,
        flexDirection:'row',
        justifyContent:'flex-end',
        backgroundColor: 'rgba(255,255,255, 0.8)',
    },
    buttonContainer: {
        flex: 1,
        flexDirection:'row',
        marginHorizontal: 10,
        marginVertical: 5,
        justifyContent: 'flex-end',
    },
    logocontainer: {
        paddingVertical: 10,
    },
    centered: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    BottomLine:{
        borderBottomWidth:1,
        borderColor:'silver',
        marginHorizontal: 30,
    },
    RowContainer:{
        flex:1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems:'center',
        paddingVertical: 20,
        marginVertical: 30,
    },
    Row1Container:{
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems:'center',
    },
    LeftContainer:{
        flex:1,
        justifyContent:'center', 
        alignItems:'center',
        marginVertical:16, 
    },
    RightContainer:{
        flex:1,
        justifyContent:'center', 
        alignItems:'flex-start',
        marginVertical:10, 
    },
    TextContainer:{
        flex:1,
        justifyContent:'flex-start',
        alignContent:'flex-start',
    },
    functionContainer:{
        flex:1,
        marginVertical:10,
        paddingHorizontal: 18,
        paddingVertical:48,
        marginHorizontal:10,
        borderRadius: 20,
        justifyContent: 'center',
        backgroundColor:'rgba(255,255,255, 0.3)',
    },
    infoContainer:{
        //flex:1,
        marginVertical:10,
        paddingHorizontal: 18,
        paddingVertical:88,
        marginHorizontal:10,
        borderRadius: 20,
        justifyContent: 'center',
        backgroundColor:'rgba(255,255,255, 0.3)',
    },
    footerContainer:{
        paddingVertical:20,
        flexDirection:'row',
        justifyContent:'space-around',
        backgroundColor: '#323232',
    },
    Button:{
        borderRadius: 15,
        backgroundColor: '#95ECD7',
        paddingVertical: 5,
        paddingHorizontal: 10,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 10,
    },

    ButtonText: {
        color: '#62737D',
        textAlign: 'center',
        margin:5
    },
    logoText:{
        textAlign: 'left',
        fontWeight: 'bold' , 
        color:'#FBB040',
        fontSize: 52,
        marginBottom: 20
    },
    logo1Text:{
        textAlign: 'left',
        fontWeight: 'bold' , 
        color:'#323232',
        fontSize: 52,
        marginBottom: 20
    },
    sloganText: {
        textAlign: 'left',
        color:'#323232',
        fontSize: 38,
        marginBottom: 20
    },
    TitleText: {
        color: '#37DC94',
        textAlign: 'center',
        fontWeight: 'bold', 
        marginTop:10,
        marginBottom: 5,
        fontSize: 18
    },
    remarkText:{
        marginHorizontal: 28,
        color:'#cccccc',
        textAlign: 'center',
        flexWrap: 'wrap',
        fontSize: 20,
    },
    InfoText: {
        marginHorizontal: 28,
        color:'#cccccc',
        textAlign: 'left',
        flexWrap: 'wrap',
        fontSize: 26,
    },
    Info1Text: {
        marginHorizontal: 26,
        color:'#323232',
        textAlign: 'left',
        fontSize: 26,
        flexWrap: 'wrap',
    },
    underlineText:{
        textDecorationLine: 'underline',
        fontWeight: 'bold', 
        marginHorizontal: 28,
        color:'#cccccc',
        textAlign: 'left',
        flexWrap: 'wrap',
        fontSize: 20,
    },
    infocolorText: {
        color: '#37DC94',
        textAlign: 'center',
        //marginVertical:10,
        //marginHorizontal: 10,
    },
    LeftText: {
        color:'#62737d',
        textAlign: 'center',
        //marginVertical:10,
        //marginHorizontal: 10,
        flexWrap: 'wrap',
    },
    footerText:{
        color:'#cccccc',
        textAlign: 'left',
        flexWrap: 'wrap',
    },

    logo: {
       //margin: 20,
        height: 68,
        width: 600,
        resizeMode: 'contain',
    },
    phone:{
        height: 680,
        width: 380,
        resizeMode: 'contain',
    },
    screenshoot:{
        flex:1,
        height: 480,
        width: 880,
        resizeMode: 'contain',
    },
    QRcode: {
        paddingTop: 10,
        paddingHorizontal: 10,
        height: 148,
        width: 148,
        resizeMode: 'contain',
    },
    background: {
        justifyContent:'center',
        height: height,
        width:width,
        resizeMode: 'contain',
        backgroundColor:'#323232'
    },
    colorBackground:{
        flex:1,
        paddingVertical:68,
        justifyContent:'center',
        backgroundColor:'#323232',
        flexWrap: 'wrap',
    },
    color1Background:{
        flex:1,
        paddingVertical:68,
        justifyContent:'center',
        backgroundColor:'#FBB040',
        flexWrap: 'wrap',
    },
    googleDownload:{
        height: 120,
        width: 240,
        resizeMode: 'contain',
        marginRight: 18
    },
    iosDownload:{
        height: 108,
        width: 190,
        resizeMode: 'contain',
        marginRight: 18
    }
}

export default ApplicationStyles